export default __webpack_public_path__ + "static/media/animate-pill.8ea12fda.svg";